import { COMPONENT_COLOR_THEMES, REGIONS, COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export type ColorTheme = 'LIGHT' | 'DARK';

export interface Props {
  region?: 'US' | 'CN';
  defaultThumbnail?: string;
  initialFilterYear?: string;
  heroSection?: {
    colorTheme?: ColorTheme;
    title?: string;
    backgroundImage?: {
      md?: string;
      _?: string;
    };
  };
  introduction: {
    title?: string;
    description?: string;
  },
  appDownload?: {
    title?: string;
    subtitle?: string;
    iosDownloadText?: string;
    androidDownloadText?: string;
    iOSStoreLink?: string;
    iOSAppLink?: string;
    androidStoreLink?: string;
    androidAppLink?: string;
    androidApkLink?: string;
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'region',
    label: 'Region',
    type: types.ENUM,
    options: REGIONS
  },
  {
    key: 'defaultThumbnail',
    label: 'Default Thumbnail',
    type: types.S3_ASSET_URL,
  },
  {
    key: 'initialFilterYear',
    label: 'The starting Year of the filter',
    type: types.TEXT,
  },
  {
    key: 'heroSection',
    label: 'Hero Section',
    type: types.OBJECT,
    children: [
      {
        key: 'colorTheme',
        label: 'Color Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'backgroundImage',
        label: 'Background Image',
        type: types.OBJECT,
        children: [
          {
            key: '_',
            label: 'Mobile (or Base)',
            type: types.S3_ASSET_URL,
          },
          {
            key: 'md',
            label: 'Desktop',
            type: types.S3_ASSET_URL,
          },
        ],
      },
    ]
  },
  {
    key: 'introduction',
    label: 'Introduction',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA,
      },
    ],
  },
  {
    key: 'appDownload',
    label: 'App Download',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'iosDownloadText',
        label: 'iOS Download Text',
        type: types.TEXT,
      },
      {
        key: 'androidDownloadText',
        label: 'Android Download Text',
        type: types.TEXT,
      },
      {
        key: 'iOSStoreLink',
        label: 'iOS Store link',
        type: types.TEXT,
      },
      {
        key: 'iOSAppLink',
        label: 'iOS App link (Deep Link)',
        type: types.TEXT,
      },
      {
        key: 'androidStoreLink',
        label: 'Android Store Link',
        type: types.TEXT,
      },
      {
        key: 'androidAppLink',
        label: 'Android App Link (Deep Link)',
        type: types.TEXT,
      },
      {
        key: 'androidApkLink',
        label: 'Android Apk Link',
        type: types.TEXT,
      },
    ],
  },
];

const defaultProps: Props = {
  region: 'US',
  defaultThumbnail: 'https://genesis-cdn.ff.com/assets/pages/press-room/Logo-Black-default-default.jpg',
  initialFilterYear: '2021',
  heroSection: {
    colorTheme: 'LIGHT',
    title: 'YT Jia\'s 10-Punch Combo',
    backgroundImage: {
      _: 'https://genesis-cdn.ff.com/assets/pages/press-room/pressroom-weekly-default.jpg',
      md: 'https://genesis-cdn.ff.com/assets/pages/press-room/pressroom-weekly-banner-default.jpg',
    },
  },
  introduction: {
    title: 'YT Jia Launches 10-Punch Combo Fully Transforms FF to Maximize Shareholder Value',
    description: 'At the all-hands meeting of Co-CEO appointment, YT announced the launch of the "10-Punch Combo", encompassing transformative initiatives in philosophy, culture and values, strategy, products and technology, manufacturing and delivery systems, user ecosystem, government affairs and strategic partnerships, corporate management, financial systems, organization and incentives, and capital and shareholder value generation. These initiatives aim to fundamentally restructure FF and maximize value for shareholders and investors.'
  },
  appDownload: {
    title: 'FF Intelligent App',
    subtitle: 'The Ultimate Intelligent TechLuxury',
    iosDownloadText: 'iOS Download',
    androidDownloadText: 'Android Download',
    iOSStoreLink: 'https://apps.apple.com/us/app/faraday-future/id1600637235?ls=1',
    iOSAppLink: 'https://faradayfuture2023.app.link/YajHk0j7Nxb',
    androidStoreLink: 'https://play.google.com/store/apps/details?id=com.faradayfuture.online.foreign',
    androidAppLink: 'faradayfuture://app-us',
    androidApkLink: 'https://www.faradayfuturecn.com/cn/apk/latest.apk',
  },
};

export default {
  title: 'Pressroom Weekly List',
  id: 'PressroomWeeklyList',
  propsSchema,
  defaultProps,
}
